// // components/events/ExpensesPanel.jsx
// import React, { useEffect, useState, useMemo, useCallback } from "react";
// import {
//   Card, Row, Col, Form, Button, Table, Spinner, Alert, Badge, Modal
// } from "react-bootstrap";
// import { db } from "../../firebase";
// import {
//   collection, query, orderBy, onSnapshot,
//   addDoc, deleteDoc, doc, updateDoc, serverTimestamp,
// } from "firebase/firestore";
// import { fmt, fmtTs, cleanObject } from "../../utils/eventUtils";

// /**
//  * Props:
//  *  - communityId: string
//  *  - event: Firestore event doc { id, committee, committeeUids, ... }
//  *  - residents: [{ uid, fullName|displayName, unit: { blockName, flatLabel }, ... }]
//  *  - canEditExpenses: boolean (Admin/Manager/Committee depending on your gating)
//  */
// export default function ExpensesPanel({ communityId, event, residents, canEditExpenses }) {
//   const eventId = event?.id;

//   const [expenses, setExpenses] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   const [adding, setAdding] = useState(false);
//   const [form, setForm] = useState({
//     purpose: "",
//     category: "",     // ✅ NEW: category
//     amount: "",
//     paidByUid: "",
//     paidByName: "",
//     receiptNo: "",
//   });

//   // Edit modal state
//   const [showEdit, setShowEdit] = useState(false);
//   const [savingEdit, setSavingEdit] = useState(false);
//   const [editExpense, setEditExpense] = useState(null); // the selected row
//   const [editForm, setEditForm] = useState({
//     purpose: "",
//     category: "",
//     amount: "",
//     paidByUid: "",
//     paidByName: "",
//     receiptNo: "",
//   });

//   const totalExpenses = useMemo(
//     () => expenses.reduce((acc, e) => acc + (Number(e.amount) || 0), 0),
//     [expenses]
//   );

//   /* ---------------------------------
//      Live: expenses
//   ---------------------------------- */
//   useEffect(() => {
//     if (!eventId) {
//       setError("Missing eventId in URL.");
//       setLoading(false);
//       return;
//     }
//     setLoading(true);
//     setError("");
//     const qExp = query(collection(db, "events", eventId, "expenses"), orderBy("createdAt", "desc"));
//     const unsub = onSnapshot(
//       qExp,
//       (snap) => {
//         const rows = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
//         setExpenses(rows);
//         setLoading(false);
//       },
//       (err) => {
//         console.error("Expenses snapshot error:", err);
//         setError(err?.message || "Failed to load expenses.");
//         setLoading(false);
//       }
//     );
//     return () => unsub();
//   }, [eventId]);

//   /* ---------------------------------
//      Helpers: Resident label by UID
//   ---------------------------------- */
//   const residentLabelByUid = useCallback(
//     (uid) => {
//       if (!uid) return "";
//       const u = (Array.isArray(residents) ? residents : []).find((x) => x.uid === uid);
//       if (!u) return uid;
//       const name = u.fullName || u.displayName || uid;
//       const b = u.unit?.blockName || "";
//       const f = u.unit?.flatLabel || "";
//       return [name, b && f ? `(${b}-${f})` : ""].filter(Boolean).join(" ");
//     },
//     [residents]
//   );

//   /* ---------------------------------
//      Committee options (UID + custom name)
//   ---------------------------------- */
//   const committeeUidOptions = useMemo(
//     () =>
//       (Array.isArray(event?.committee) ? event.committee : [])
//         .filter((m) => m?.uid)
//         .map((m) => ({
//           uid: m.uid,
//           label: residentLabelByUid(m.uid) || m.uid,
//         })),
//     [event?.committee, residentLabelByUid]
//   );

//   const committeeNameOptions = useMemo(
//     () =>
//       (Array.isArray(event?.committee) ? event.committee : [])
//         .filter((m) => !m?.uid && (m?.residentName || "").trim())
//         .map((m) => ({
//           name: (m.residentName || "").trim(),
//         })),
//     [event?.committee]
//   );

//   /* ---------------------------------
//      Add expense
//   ---------------------------------- */
//   const addExpense = async () => {
//     if (!canEditExpenses) return alert("Not allowed for your role.");
//     if (!eventId) return alert("Missing eventId; check the URL.");

//     const purpose = String(form.purpose || "").trim();
//     const category = String(form.category || "").trim(); // ✅ NEW
//     const amt = Number(form.amount);

//     if (!purpose) return alert("Purpose is required.");
//     if (!category) return alert("Category is required."); // ✅ NEW validation
//     if (!(amt > 0)) return alert("Amount must be > 0.");

//     const payload = cleanObject({
//       communityId: String(communityId || ""),
//       eventId: String(eventId || ""),
//       purpose,
//       category, // ✅ NEW: persisted in Firestore
//       amount: amt,
//       // prefer UID, but keep name for readability
//       paidByUid: typeof form.paidByUid === "string" && form.paidByUid ? form.paidByUid : undefined,
//       paidByName: (form.paidByName || "").trim(),
//       receiptNo: (form.receiptNo || "").trim(),
//       createdAt: serverTimestamp(),
//     });

//     try {
//       setAdding(true);
//       await addDoc(collection(db, "events", eventId, "expenses"), payload);
//       setForm({
//         purpose: "",
//         category: "",   // ✅ clear
//         amount: "",
//         paidByUid: "",
//         paidByName: "",
//         receiptNo: "",
//       });
//     } catch (err) {
//       console.error("Add expense error:", err);
//       alert(err?.message || "Failed to add expense.");
//     } finally {
//       setAdding(false);
//     }
//   };

//   /* ---------------------------------
//      Edit expense (open modal, save changes)
//   ---------------------------------- */
//   const openEdit = (exp) => {
//     setEditExpense(exp);
//     setEditForm({
//       purpose: exp.purpose || "",
//       category: exp.category || "", // may be empty in older rows
//       amount: String(exp.amount ?? ""),
//       paidByUid: exp.paidByUid || "",
//       paidByName: exp.paidByName || "",
//       receiptNo: exp.receiptNo || "",
//     });
//     setShowEdit(true);
//   };

//   const closeEdit = () => {
//     setShowEdit(false);
//     setEditExpense(null);
//     setSavingEdit(false);
//   };

//   const saveEdit = async () => {
//     if (!canEditExpenses) return alert("Not allowed for your role.");
//     if (!eventId || !editExpense?.id) return alert("Invalid expense selected.");

//     const purpose = String(editForm.purpose || "").trim();
//     const category = String(editForm.category || "").trim();
//     const amt = Number(editForm.amount);

//     if (!purpose) return alert("Purpose is required.");
//     if (!category) return alert("Category is required.");
//     if (!(amt > 0)) return alert("Amount must be > 0.");

//     // When UID is selected, keep it; otherwise rely on name.
//     const payload = cleanObject({
//       purpose,
//       category,
//       amount: amt,
//       paidByUid: typeof editForm.paidByUid === "string" && editForm.paidByUid ? editForm.paidByUid : undefined,
//       paidByName: (editForm.paidByName || "").trim(),
//       receiptNo: (editForm.receiptNo || "").trim(),
//       // Optional: track updatedAt to know edits later
//       updatedAt: serverTimestamp(),
//     });

//     try {
//       setSavingEdit(true);
//       await updateDoc(doc(db, "events", eventId, "expenses", editExpense.id), payload);
//       closeEdit();
//     } catch (err) {
//       console.error("Update expense error:", err);
//       alert(err?.message || "Failed to update expense.");
//       setSavingEdit(false);
//     }
//   };

//   const deleteExpense = async (id) => {
//     if (!canEditExpenses) return alert("Not allowed for your role.");
//     if (!eventId) return alert("Missing eventId; check the URL.");
//     if (!window.confirm("Delete this expense?")) return;
//     try {
//       await deleteDoc(doc(db, "events", eventId, "expenses", id));
//     } catch (err) {
//       console.error("Delete expense error:", err);
//       alert(err?.message || "Failed to delete expense.");
//     }
//   };

//   /* ---------------------------------
//      Render
//   ---------------------------------- */
//   return (
//     <div>
//       <div className="d-flex align-items-center justify-content-between">
//         <h6 className="mb-3">Expenses</h6>
//         <div>
//           <Badge bg="danger" className="me-2">Total Expenses: ₹ {fmt(totalExpenses)}</Badge>
//         </div>
//       </div>

//       {canEditExpenses && (
//         <Card className="mb-3">
//           <Card.Body>
//             <Row className="g-2">
//               {/* Purpose */}
//               <Col md={4}>
//                 <Form.Label>Purpose</Form.Label>
//                 <Form.Control
//                   type="text"
//                   placeholder="e.g., Stage, Decorations"
//                   value={form.purpose}
//                   onChange={(e) => setForm((s) => ({ ...s, purpose: e.target.value }))}
//                 />
//               </Col>

//               {/* Category (NEW) */}
//               <Col md={3}>
//                 <Form.Label>Category</Form.Label>
//                 <Form.Control
//                   type="text"
//                   placeholder="e.g., Catering, Games, Decorations"
//                   value={form.category}
//                   onChange={(e) => setForm((s) => ({ ...s, category: e.target.value }))}
//                 />
//                 {/* If you prefer preset choices, replace the input above with:
//                 <Form.Select
//                   value={form.category}
//                   onChange={(e) => setForm((s) => ({ ...s, category: e.target.value }))}
//                 >
//                   <option value="">— Select category —</option>
//                   <option value="Catering">Catering</option>
//                   <option value="Games">Games</option>
//                   <option value="Decorations">Decorations</option>
//                   <option value="Logistics">Logistics</option>
//                   <option value="Gifts">Gifts</option>
//                   <option value="Misc">Misc</option>
//                 </Form.Select>
//                 */}
//               </Col>

//               {/* Amount */}
//               <Col md={2}>
//                 <Form.Label>Amount (₹)</Form.Label>
//                 <Form.Control
//                   type="number"
//                   min="0"
//                   step="0.01"
//                   value={form.amount}
//                   onChange={(e) => setForm((s) => ({ ...s, amount: e.target.value }))}
//                 />
//               </Col>

//               {/* Paid By (Committee) — UID or custom name */}
//               <Col md={3}>
//                 <Form.Label>Paid By (Committee)</Form.Label>
//                 <Form.Select
//                   value={
//                     form.paidByUid
//                       ? `uid:${form.paidByUid}`
//                       : form.paidByName
//                       ? `name:${form.paidByName}`
//                       : ""
//                   }
//                   onChange={(e) => {
//                     const val = e.target.value;
//                     if (val.startsWith("uid:")) {
//                       const uid = val.slice(4);
//                       const resolvedName = residentLabelByUid(uid) || "";
//                       setForm((s) => ({ ...s, paidByUid: uid, paidByName: resolvedName }));
//                     } else if (val.startsWith("name:")) {
//                       const name = val.slice(5);
//                       setForm((s) => ({ ...s, paidByUid: "", paidByName: name }));
//                     } else {
//                       setForm((s) => ({ ...s, paidByUid: "", paidByName: "" }));
//                     }
//                   }}
//                 >
//                   <option value="">— Select committee member —</option>

//                   {/* Registered (UID) */}
//                   {committeeUidOptions.map((opt, idx) => (
//                     <option key={`exp-committee-uid-${opt.uid}-${idx}`} value={`uid:${opt.uid}`}>
//                       {opt.label}
//                     </option>
//                   ))}

//                   {/* Custom names */}
//                   {committeeNameOptions.map((opt, idx) => (
//                     <option key={`exp-committee-name-${opt.name}-${idx}`} value={`name:${opt.name}`}>
//                       {opt.name}
//                     </option>
//                   ))}
//                 </Form.Select>
//                 <div className="form-text">
//                   Pick a registered member or a custom name. You can also override below.
//                 </div>
//               </Col>

//               {/* Paid By (Name) — manual override or non-committee payer */}
//               <Col md={3}>
//                 <Form.Label>Paid By (Name)</Form.Label>
//                 <Form.Control
//                   value={form.paidByName}
//                   onChange={(e) => setForm((s) => ({ ...s, paidByName: e.target.value }))}
//                   placeholder="optional (if not in committee)"
//                 />
//               </Col>

//               {/* Receipt No */}
//               <Col md={2}>
//                 <Form.Label>Receipt No</Form.Label>
//                 <Form.Control
//                   value={form.receiptNo}
//                   onChange={(e) => setForm((s) => ({ ...s, receiptNo: e.target.value }))}
//                 />
//               </Col>
//             </Row>

//             <div className="mt-3">
//               <Button
//                 variant="primary"
//                 onClick={addExpense}
//                 disabled={adding || !form.purpose || !form.category || !form.amount}
//               >
//                 {adding ? "Saving…" : "Add Expense"}
//               </Button>
//             </div>
//           </Card.Body>
//         </Card>
//       )}

//       {error && <Alert variant="danger">{error}</Alert>}
//       {loading ? (
//         <div className="d-flex align-items-center">
//           <Spinner animation="border" size="sm" className="me-2" />
//           <span>Loading expenses…</span>
//         </div>
//       ) : (
//         <Table bordered hover responsive size="sm">
//           <thead>
//             <tr>
//               <th>Purpose</th>
//               <th>Category</th> {/* ✅ NEW column */}
//               <th>Amount (₹)</th>
//               <th>Paid By</th>
//               <th>Receipt</th>
//               <th>Created</th>
//               {canEditExpenses && <th style={{ width: 160 }}>Actions</th>} {/* widened for 2 buttons */}
//             </tr>
//           </thead>
//           <tbody>
//             {expenses.length === 0 ? (
//               <tr>
//                 <td colSpan={canEditExpenses ? 7 : 6} className="text-center">
//                   No expenses yet
//                 </td>
//               </tr>
//             ) : (
//               expenses.map((e) => {
//                 const paidBy =
//                   e.paidByUid
//                     ? (residentLabelByUid(e.paidByUid) || e.paidByUid)
//                     : (e.paidByName || "—");

//                 return (
//                   <tr key={e.id}>
//                     <td>{e.purpose || "—"}</td>
//                     <td>{e.category || "—"}</td> {/* ✅ renders even for old rows */}
//                     <td>₹ {fmt(e.amount)}</td>
//                     <td>{paidBy}</td>
//                     <td>{e.receiptNo || "—"}</td>
//                     <td>{fmtTs(e.createdAt)}</td>
//                     {canEditExpenses && (
//                       <td className="d-flex gap-2">
//                         <Button
//                           variant="outline-secondary"
//                           size="sm"
//                           onClick={() => openEdit(e)}
//                         >
//                           Edit
//                         </Button>
//                         <Button
//                           variant="outline-danger"
//                           size="sm"
//                           onClick={() => deleteExpense(e.id)}
//                         >
//                           Delete
//                         </Button>
//                       </td>
//                     )}
//                   </tr>
//                 );
//               })
//             )}
//           </tbody>
//         </Table>
//       )}

//       {/* Edit Modal */}
//       <Modal show={showEdit} onHide={closeEdit} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Edit Expense</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           {editExpense ? (
//             <Row className="g-2">
//               {/* Purpose */}
//               <Col md={6}>
//                 <Form.Label>Purpose</Form.Label>
//                 <Form.Control
//                   type="text"
//                   value={editForm.purpose}
//                   onChange={(e) => setEditForm((s) => ({ ...s, purpose: e.target.value }))}
//                 />
//               </Col>

//               {/* Category */}
//               <Col md={6}>
//                 <Form.Label>Category</Form.Label>
//                 <Form.Control
//                   type="text"
//                   value={editForm.category}
//                   onChange={(e) => setEditForm((s) => ({ ...s, category: e.target.value }))}
//                 />
//               </Col>

//               {/* Amount */}
//               <Col md={4}>
//                 <Form.Label>Amount (₹)</Form.Label>
//                 <Form.Control
//                   type="number"
//                   min="0"
//                   step="0.01"
//                   value={editForm.amount}
//                   onChange={(e) => setEditForm((s) => ({ ...s, amount: e.target.value }))}
//                 />
//               </Col>

//               {/* Paid By (Committee) — UID or custom name */}
//               <Col md={8}>
//                 <Form.Label>Paid By (Committee)</Form.Label>
//                 <Form.Select
//                   value={
//                     editForm.paidByUid
//                       ? `uid:${editForm.paidByUid}`
//                       : editForm.paidByName
//                       ? `name:${editForm.paidByName}`
//                       : ""
//                   }
//                   onChange={(e) => {
//                     const val = e.target.value;
//                     if (val.startsWith("uid:")) {
//                       const uid = val.slice(4);
//                       const resolvedName = residentLabelByUid(uid) || "";
//                       setEditForm((s) => ({ ...s, paidByUid: uid, paidByName: resolvedName }));
//                     } else if (val.startsWith("name:")) {
//                       const name = val.slice(5);
//                       setEditForm((s) => ({ ...s, paidByUid: "", paidByName: name }));
//                     } else {
//                       setEditForm((s) => ({ ...s, paidByUid: "", paidByName: "" }));
//                     }
//                   }}
//                 >
//                   <option value="">— Select committee member —</option>

//                   {/* Registered (UID) */}
//                   {committeeUidOptions.map((opt, idx) => (
//                     <option key={`edit-committee-uid-${opt.uid}-${idx}`} value={`uid:${opt.uid}`}>
//                       {opt.label}
//                     </option>
//                   ))}

//                   {/* Custom names */}
//                   {committeeNameOptions.map((opt, idx) => (
//                     <option key={`edit-committee-name-${opt.name}-${idx}`} value={`name:${opt.name}`}>
//                       {opt.name}
//                     </option>
//                   ))}
//                 </Form.Select>
//               </Col>

//               {/* Paid By (Name) — manual override */}
//               <Col md={8}>
//                 <Form.Label>Paid By (Name)</Form.Label>
//                 <Form.Control
//                   value={editForm.paidByName}
//                   onChange={(e) => setEditForm((s) => ({ ...s, paidByName: e.target.value }))}
//                   placeholder="optional (if not in committee)"
//                 />
//               </Col>

//               {/* Receipt No */}
//               <Col md={4}>
//                 <Form.Label>Receipt No</Form.Label>
//                 <Form.Control
//                   value={editForm.receiptNo}
//                   onChange={(e) => setEditForm((s) => ({ ...s, receiptNo: e.target.value }))}
//                 />
//               </Col>
//             </Row>
//           ) : (
//             <Alert variant="warning">No expense selected.</Alert>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={closeEdit} disabled={savingEdit}>
//             Cancel
//           </Button>
//           <Button
//             variant="primary"
//             onClick={saveEdit}
//             disabled={savingEdit || !editForm.purpose || !editForm.category || !editForm.amount}
//           >
//             {savingEdit ? "Saving…" : "Save Changes"}
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// }

// components/events/ExpensesPanel.jsx

import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";

import {
  Alert,
  Badge,
  Button,
  Card,
  Col,
  Form,
  Modal,
  Row,
  Spinner,
  Table,
} from "react-bootstrap";

import {
  addDoc,
  collection,
  deleteDoc,
  deleteField,
  doc,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
  updateDoc,
} from "firebase/firestore";

import { db } from "../../firebase";
import { cleanObject, fmt, fmtTs } from "../../utils/eventUtils";

const ADD_NEW_CATEGORY_VALUE = "__ADD_NEW_CATEGORY__";

const PAYMENT_MODES = [
  "Cash",
  "UPI",
  "Bank Transfer",
  "Credit Card",
  "Debit Card",
  "Cheque",
  "Other",
];

const getTodayDate = () => {
  const now = new Date();
  const timezoneOffset = now.getTimezoneOffset() * 60000;

  return new Date(now.getTime() - timezoneOffset)
    .toISOString()
    .split("T")[0];
};

const getInitialExpenseForm = () => ({
  purpose: "",
  category: "",
  amount: "",
  paidByUid: "",
  paidByName: "",
  receiptNo: "",
  expenseDate: getTodayDate(),
  paymentMode: "",
});

const getPaidByKey = (expense) => {
  if (expense?.paidByUid) {
    return `uid:${expense.paidByUid}`;
  }

  const paidByName = String(expense?.paidByName || "").trim();

  if (paidByName) {
    return `name:${paidByName.toLowerCase()}`;
  }

  return "";
};

const formatDisplayDate = (dateString) => {
  if (!dateString) return "-";

  const [year, month, day] = dateString.split("-");

  return `${day}-${month}-${year}`;
};

export default function ExpensesPanel({
  communityId,
  event,
  residents,
  canEditExpenses,
}) {
  const eventId = event?.id;

  const [expenses, setExpenses] = useState([]);
  const [storedCategories, setStoredCategories] = useState([]);

  const [loading, setLoading] = useState(true);
  const [categoriesLoading, setCategoriesLoading] = useState(true);
  const [error, setError] = useState("");

  const [adding, setAdding] = useState(false);
  const [form, setForm] = useState(getInitialExpenseForm);

  const [showEdit, setShowEdit] = useState(false);
  const [savingEdit, setSavingEdit] = useState(false);
  const [editExpense, setEditExpense] = useState(null);
  const [editForm, setEditForm] = useState(getInitialExpenseForm);

  const [showCategoryModal, setShowCategoryModal] = useState(false);
  const [categoryModalTarget, setCategoryModalTarget] = useState("add");
  const [newCategoryName, setNewCategoryName] = useState("");
  const [savingCategory, setSavingCategory] = useState(false);
  const [categoryError, setCategoryError] = useState("");

  const [categoryFilter, setCategoryFilter] = useState("");
  const [paidByFilter, setPaidByFilter] = useState("");
  const [paymentModeFilter, setPaymentModeFilter] = useState("");
  const [fromDateFilter, setFromDateFilter] = useState("");
  const [toDateFilter, setToDateFilter] = useState("");

  // delete confirmation
  const [showDeleteModal, setShowDeleteModal] = useState(false);
const [expenseToDelete, setExpenseToDelete] = useState(null);
const [deleteConfirmation, setDeleteConfirmation] = useState("");
const [deletingExpense, setDeletingExpense] = useState(false);
const [deleteError, setDeleteError] = useState("");
const [showAddExpenseModal, setShowAddExpenseModal] = useState(false);

  useEffect(() => {
    if (!eventId) {
      setError("Missing eventId in URL.");
      setLoading(false);
      return undefined;
    }

    setLoading(true);
    setError("");

    const expensesQuery = query(
      collection(db, "events", eventId, "expenses"),
      orderBy("createdAt", "desc")
    );

    const unsubscribe = onSnapshot(
      expensesQuery,
      (snapshot) => {
        const rows = snapshot.docs.map((expenseDoc) => ({
          id: expenseDoc.id,
          ...expenseDoc.data(),
        }));

        setExpenses(rows);
        setLoading(false);
      },
      (snapshotError) => {
        console.error("Expenses snapshot error:", snapshotError);
        setError(snapshotError?.message || "Failed to load expenses.");
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [eventId]);

  useEffect(() => {
    if (!eventId) {
      setStoredCategories([]);
      setCategoriesLoading(false);
      return undefined;
    }

    setCategoriesLoading(true);

    const categoriesQuery = query(
      collection(db, "events", eventId, "expenseCategories"),
      orderBy("nameLower", "asc")
    );

    const unsubscribe = onSnapshot(
      categoriesQuery,
      (snapshot) => {
        const rows = snapshot.docs.map((categoryDoc) => ({
          id: categoryDoc.id,
          ...categoryDoc.data(),
        }));

        setStoredCategories(rows);
        setCategoriesLoading(false);
      },
      (snapshotError) => {
        console.error("Expense categories snapshot error:", snapshotError);
        setCategoriesLoading(false);
      }
    );

    return () => unsubscribe();
  }, [eventId]);

  const residentLabelByUid = useCallback(
    (uid) => {
      if (!uid) {
        return "";
      }

      const resident = (Array.isArray(residents) ? residents : []).find(
        (item) => item.uid === uid
      );

      if (!resident) {
        return uid;
      }

      const residentName =
        resident.fullName || resident.displayName || resident.uid;

      const blockName = resident.unit?.blockName || "";
      const flatLabel = resident.unit?.flatLabel || "";

      const unitLabel =
        blockName && flatLabel ? `(${blockName}-${flatLabel})` : "";

      return [residentName, unitLabel].filter(Boolean).join(" ");
    },
    [residents]
  );

  const committeeUidOptions = useMemo(() => {
    const members = Array.isArray(event?.committee) ? event.committee : [];
    const uniqueMembers = new Map();

    members
      .filter((member) => member?.uid)
      .forEach((member) => {
        if (!uniqueMembers.has(member.uid)) {
          uniqueMembers.set(member.uid, {
            uid: member.uid,
            label: residentLabelByUid(member.uid) || member.uid,
          });
        }
      });

    return Array.from(uniqueMembers.values()).sort((a, b) =>
      a.label.localeCompare(b.label)
    );
  }, [event?.committee, residentLabelByUid]);

  const committeeNameOptions = useMemo(() => {
    const members = Array.isArray(event?.committee) ? event.committee : [];
    const uniqueNames = new Map();

    members
      .filter(
        (member) =>
          !member?.uid && String(member?.residentName || "").trim()
      )
      .forEach((member) => {
        const name = String(member.residentName).trim();
        const normalizedName = name.toLowerCase();

        if (!uniqueNames.has(normalizedName)) {
          uniqueNames.set(normalizedName, { name });
        }
      });

    return Array.from(uniqueNames.values()).sort((a, b) =>
      a.name.localeCompare(b.name)
    );
  }, [event?.committee]);

  const categoryOptions = useMemo(() => {
    const categoriesMap = new Map();

    storedCategories.forEach((category) => {
      const name = String(category?.name || "").trim();

      if (name) {
        categoriesMap.set(name.toLowerCase(), name);
      }
    });

    expenses.forEach((expense) => {
      const name = String(expense?.category || "").trim();

      if (name && !categoriesMap.has(name.toLowerCase())) {
        categoriesMap.set(name.toLowerCase(), name);
      }
    });

    return Array.from(categoriesMap.values()).sort((a, b) =>
      a.localeCompare(b)
    );
  }, [storedCategories, expenses]);

  const paidByFilterOptions = useMemo(() => {
    const optionsMap = new Map();

    expenses.forEach((expense) => {
      const key = getPaidByKey(expense);

      if (!key) {
        return;
      }

      const label = expense.paidByUid
        ? residentLabelByUid(expense.paidByUid) ||
          expense.paidByName ||
          expense.paidByUid
        : expense.paidByName;

      if (!optionsMap.has(key)) {
        optionsMap.set(key, {
          value: key,
          label: label || "Unknown",
        });
      }
    });

    return Array.from(optionsMap.values()).sort((a, b) =>
      a.label.localeCompare(b.label)
    );
  }, [expenses, residentLabelByUid]);

  const filteredExpenses = useMemo(() => {
    return expenses.filter((expense) => {
      const expenseCategory = String(expense.category || "")
        .trim()
        .toLowerCase();

      const selectedCategory = String(categoryFilter || "")
        .trim()
        .toLowerCase();

      const matchesCategory =
        !selectedCategory || expenseCategory === selectedCategory;

      const expensePaidByKey = getPaidByKey(expense);
      const matchesPaidBy =
        !paidByFilter || expensePaidByKey === paidByFilter;

      const expensePaymentMode = String(expense.paymentMode || "")
        .trim()
        .toLowerCase();

      const selectedPaymentMode = String(paymentModeFilter || "")
        .trim()
        .toLowerCase();

      const matchesPaymentMode =
        !selectedPaymentMode ||
        expensePaymentMode === selectedPaymentMode;

      const expenseDate = String(expense.expenseDate || "").trim();

      const matchesFromDate =
        !fromDateFilter ||
        (expenseDate && expenseDate >= fromDateFilter);

      const matchesToDate =
        !toDateFilter ||
        (expenseDate && expenseDate <= toDateFilter);

      return (
        matchesCategory &&
        matchesPaidBy &&
        matchesPaymentMode &&
        matchesFromDate &&
        matchesToDate
      );
    });
  }, [
    expenses,
    categoryFilter,
    paidByFilter,
    paymentModeFilter,
    fromDateFilter,
    toDateFilter,
  ]);

// const sortedExpenses = useMemo(() => {
//   return [...filteredExpenses].sort((a, b) => {
//     const dateA = a.expenseDate || "";
//     const dateB = b.expenseDate || "";

//     return dateA.localeCompare(dateB);
//   });
// }, [filteredExpenses]);

const getCreatedTime = (expense) => {
  if (expense?.createdAt?.toMillis) {
    return expense.createdAt.toMillis();
  }

  if (expense?.createdAt?.seconds) {
    return expense.createdAt.seconds * 1000;
  }

  return 0;
};

const sortedExpenses = useMemo(() => {
  return [...filteredExpenses].sort((expenseA, expenseB) => {
    const dateA = String(expenseA.expenseDate || "");
    const dateB = String(expenseB.expenseDate || "");

    const dateComparison = dateA.localeCompare(dateB);

    if (dateComparison !== 0) {
      return dateComparison;
    }

    const createdTimeA = getCreatedTime(expenseA);
    const createdTimeB = getCreatedTime(expenseB);

    return createdTimeA - createdTimeB;
  });
}, [filteredExpenses]);

  const totalExpenses = useMemo(() => {
    return expenses.reduce(
      (total, expense) => total + (Number(expense.amount) || 0),
      0
    );
  }, [expenses]);

  const filteredTotalExpenses = useMemo(() => {
    return filteredExpenses.reduce(
      (total, expense) => total + (Number(expense.amount) || 0),
      0
    );
  }, [filteredExpenses]);

  const hasActiveFilters = Boolean(
    categoryFilter ||
      paidByFilter ||
      paymentModeFilter ||
      fromDateFilter ||
      toDateFilter
  );

  const filterTotalLabel = useMemo(() => {
  if (categoryFilter) {
    return `${categoryFilter}: ₹ ${fmt(filteredTotalExpenses)}`;
  }

  if (hasActiveFilters) {
    return `Filtered Total: ₹ ${fmt(filteredTotalExpenses)}`;
  }

  return `All Expenses: ₹ ${fmt(totalExpenses)}`;
}, [
  categoryFilter,
  filteredTotalExpenses,
  hasActiveFilters,
  totalExpenses,
]);

  const openAddCategoryModal = (target) => {
    setCategoryModalTarget(target);
    setNewCategoryName("");
    setCategoryError("");
    setShowCategoryModal(true);
  };

  const closeCategoryModal = () => {
    if (savingCategory) {
      return;
    }

    setShowCategoryModal(false);
    setNewCategoryName("");
    setCategoryError("");
  };

  const handleCategorySelection = (value, target) => {
    if (value === ADD_NEW_CATEGORY_VALUE) {
      openAddCategoryModal(target);
      return;
    }

    if (target === "edit") {
      setEditForm((previousForm) => ({
        ...previousForm,
        category: value,
      }));
      return;
    }

    setForm((previousForm) => ({
      ...previousForm,
      category: value,
    }));
  };

  const saveNewCategory = async () => {
    if (!canEditExpenses) {
      setCategoryError("You are not allowed to add a category.");
      return;
    }

    if (!eventId) {
      setCategoryError("Missing eventId.");
      return;
    }

    const categoryName = String(newCategoryName || "").trim();

    if (!categoryName) {
      setCategoryError("Category name is required.");
      return;
    }

    const categoryAlreadyExists = categoryOptions.some(
      (category) =>
        category.toLowerCase() === categoryName.toLowerCase()
    );

    if (categoryAlreadyExists) {
      setCategoryError("This category already exists.");
      return;
    }

    try {
      setSavingCategory(true);
      setCategoryError("");

      await addDoc(
        collection(db, "events", eventId, "expenseCategories"),
        {
          communityId: String(communityId || ""),
          eventId: String(eventId),
          name: categoryName,
          nameLower: categoryName.toLowerCase(),
          createdAt: serverTimestamp(),
        }
      );

      if (categoryModalTarget === "edit") {
        setEditForm((previousForm) => ({
          ...previousForm,
          category: categoryName,
        }));
      } else {
        setForm((previousForm) => ({
          ...previousForm,
          category: categoryName,
        }));
      }

      setShowCategoryModal(false);
      setNewCategoryName("");
      setCategoryError("");
    } catch (saveError) {
      console.error("Add expense category error:", saveError);
      setCategoryError(
        saveError?.message || "Failed to add category."
      );
    } finally {
      setSavingCategory(false);
    }
  };

  const validateExpenseForm = (expenseForm) => {
    const purpose = String(expenseForm.purpose || "").trim();
    const category = String(expenseForm.category || "").trim();
    const amount = Number(expenseForm.amount);
    const expenseDate = String(expenseForm.expenseDate || "").trim();
    const paymentMode = String(expenseForm.paymentMode || "").trim();

    if (!purpose) {
      return "Purpose is required.";
    }

    if (!category) {
      return "Category is required.";
    }

    if (!Number.isFinite(amount) || amount <= 0) {
      return "Amount must be greater than 0.";
    }

    if (!expenseDate) {
      return "Expense date is required.";
    }

    if (!paymentMode) {
      return "Payment mode is required.";
    }

    return "";
  };

    const addExpense = async () => {
    if (!canEditExpenses) {
      window.alert("Not allowed for your role.");
      return;
    }

    if (!eventId) {
      window.alert("Missing eventId. Check the URL.");
      return;
    }

    const validationMessage = validateExpenseForm(form);

    if (validationMessage) {
      window.alert(validationMessage);
      return;
    }

    const payload = cleanObject({
      communityId: String(communityId || ""),
      eventId: String(eventId),
      purpose: String(form.purpose || "").trim(),
      category: String(form.category || "").trim(),
      amount: Number(form.amount),
      paidByUid: form.paidByUid || undefined,
      paidByName: String(form.paidByName || "").trim(),
      receiptNo: String(form.receiptNo || "").trim(),
      expenseDate: String(form.expenseDate || "").trim(),
      paymentMode: String(form.paymentMode || "").trim(),
      createdAt: serverTimestamp(),
    });

    try {
      setAdding(true);

      await addDoc(
        collection(db, "events", eventId, "expenses"),
        payload
      );

      setForm(getInitialExpenseForm());
      setShowAddExpenseModal(false);
    } catch (addError) {
      console.error("Add expense error:", addError);
      window.alert(
        addError?.message || "Failed to add expense."
      );
    } finally {
      setAdding(false);
    }
  };

  const openEdit = (expense) => {
    setEditExpense(expense);

    setEditForm({
      purpose: expense.purpose || "",
      category: expense.category || "",
      amount: String(expense.amount ?? ""),
      paidByUid: expense.paidByUid || "",
      paidByName: expense.paidByName || "",
      receiptNo: expense.receiptNo || "",
      expenseDate: expense.expenseDate || getTodayDate(),
      paymentMode: expense.paymentMode || "",
    });

    setShowEdit(true);
  };

  const closeEdit = () => {
    if (savingEdit) {
      return;
    }

    setShowEdit(false);
    setEditExpense(null);
    setEditForm(getInitialExpenseForm());
  };

  const saveEdit = async () => {
    if (!canEditExpenses) {
      window.alert("Not allowed for your role.");
      return;
    }

    if (!eventId || !editExpense?.id) {
      window.alert("Invalid expense selected.");
      return;
    }

    const validationMessage = validateExpenseForm(editForm);

    if (validationMessage) {
      window.alert(validationMessage);
      return;
    }

    const payload = {
      purpose: String(editForm.purpose || "").trim(),
      category: String(editForm.category || "").trim(),
      amount: Number(editForm.amount),
      paidByName: String(editForm.paidByName || "").trim(),
      receiptNo: String(editForm.receiptNo || "").trim(),
      expenseDate: String(editForm.expenseDate || "").trim(),
      paymentMode: String(editForm.paymentMode || "").trim(),
      paidByUid: editForm.paidByUid
        ? editForm.paidByUid
        : deleteField(),
      updatedAt: serverTimestamp(),
    };

    try {
      setSavingEdit(true);

      await updateDoc(
        doc(
          db,
          "events",
          eventId,
          "expenses",
          editExpense.id
        ),
        payload
      );

      setShowEdit(false);
      setEditExpense(null);
      setEditForm(getInitialExpenseForm());
    } catch (updateError) {
      console.error("Update expense error:", updateError);
      window.alert(
        updateError?.message || "Failed to update expense."
      );
    } finally {
      setSavingEdit(false);
    }
  };

  // const deleteExpense = async (expenseId) => {
  //   if (!canEditExpenses) {
  //     window.alert("Not allowed for your role.");
  //     return;
  //   }

  //   if (!eventId) {
  //     window.alert("Missing eventId. Check the URL.");
  //     return;
  //   }

  //   const confirmed = window.confirm(
  //     "Are you sure you want to delete this expense?"
  //   );

  //   if (!confirmed) {
  //     return;
  //   }

  //   try {
  //     await deleteDoc(
  //       doc(db, "events", eventId, "expenses", expenseId)
  //     );
  //   } catch (deleteError) {
  //     console.error("Delete expense error:", deleteError);
  //     window.alert(
  //       deleteError?.message || "Failed to delete expense."
  //     );
  //   }
  // };

  const openDeleteModal = (expense) => {
  if (!canEditExpenses) {
    window.alert("Not allowed for your role.");
    return;
  }

  if (!eventId) {
    window.alert("Missing eventId. Check the URL.");
    return;
  }

  setExpenseToDelete(expense);
  setDeleteConfirmation("");
  setDeleteError("");
  setShowDeleteModal(true);
};

const closeDeleteModal = () => {
  if (deletingExpense) {
    return;
  }

  setShowDeleteModal(false);
  setExpenseToDelete(null);
  setDeleteConfirmation("");
  setDeleteError("");
};

const confirmDeleteExpense = async () => {
  if (!canEditExpenses) {
    setDeleteError("Not allowed for your role.");
    return;
  }

  if (!eventId) {
    setDeleteError("Missing eventId. Check the URL.");
    return;
  }

  if (!expenseToDelete?.id) {
    setDeleteError("No expense was selected.");
    return;
  }

  if (deleteConfirmation.trim() !== "DELETE") {
    setDeleteError('Enter "DELETE" exactly to confirm.');
    return;
  }

  try {
    setDeletingExpense(true);
    setDeleteError("");

    await deleteDoc(
      doc(
        db,
        "events",
        eventId,
        "expenses",
        expenseToDelete.id
      )
    );

    setShowDeleteModal(false);
    setExpenseToDelete(null);
    setDeleteConfirmation("");
    setDeleteError("");
  } catch (deleteExpenseError) {
    console.error(
      "Delete expense error:",
      deleteExpenseError
    );

    setDeleteError(
      deleteExpenseError?.message ||
        "Failed to delete expense."
    );
  } finally {
    setDeletingExpense(false);
  }
};

  const handlePaidByChange = (value, isEdit = false) => {
    const updateForm = isEdit ? setEditForm : setForm;

    if (value.startsWith("uid:")) {
      const uid = value.slice(4);

      updateForm((previousForm) => ({
        ...previousForm,
        paidByUid: uid,
        paidByName: residentLabelByUid(uid) || "",
      }));

      return;
    }

    if (value.startsWith("name:")) {
      const name = value.slice(5);

      updateForm((previousForm) => ({
        ...previousForm,
        paidByUid: "",
        paidByName: name,
      }));

      return;
    }

    updateForm((previousForm) => ({
      ...previousForm,
      paidByUid: "",
      paidByName: "",
    }));
  };

  const resetFilters = () => {
    setCategoryFilter("");
    setPaidByFilter("");
    setPaymentModeFilter("");
    setFromDateFilter("");
    setToDateFilter("");
  };

  const openAddExpenseModal = () => {
  setShowAddExpenseModal(true);
};

const closeAddExpenseModal = () => {
  if (adding) {
    return;
  }

  setShowAddExpenseModal(false);
};

  const renderCategoryOptions = (prefix) => (
    <>
      {categoryOptions.map((category) => (
        <option
          key={`${prefix}-${category}`}
          value={category}
        >
          {category}
        </option>
      ))}

      <option value={ADD_NEW_CATEGORY_VALUE}>
        Add New Category
      </option>
    </>
  );

  const renderPaymentModes = (prefix) =>
    PAYMENT_MODES.map((paymentMode) => (
      <option
        key={`${prefix}-${paymentMode}`}
        value={paymentMode}
      >
        {paymentMode}
      </option>
    ));

  const renderCommitteeOptions = (prefix) => (
    <>
      {committeeUidOptions.map((option) => (
        <option
          key={`${prefix}-uid-${option.uid}`}
          value={`uid:${option.uid}`}
        >
          {option.label}
        </option>
      ))}

      {committeeNameOptions.map((option) => (
        <option
          key={`${prefix}-name-${option.name}`}
          value={`name:${option.name}`}
        >
          {option.name}
        </option>
      ))}
    </>
  );
  

  return (
    <div>
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3">
        <h6 className="mb-0">Expenses</h6>

        <div className="d-flex flex-wrap gap-2">
          <Badge bg="danger">
            Total Expenses: ₹ {fmt(totalExpenses)}
          </Badge>

          {hasActiveFilters && (
            <Badge bg="primary">
              Filtered Total: ₹ {fmt(filteredTotalExpenses)}
            </Badge>
          )}
        </div>
      </div>

      {/* {canEditExpenses && (
        <Card className="mb-3">
          <Card.Header>
            <strong>Add Expense</strong>
          </Card.Header>

          <Card.Body>
            <Row className="g-3">
              <Col md={4}>
                <Form.Label>Purpose</Form.Label>

                <Form.Control
                  type="text"
                  placeholder="Example: Stage or decorations"
                  value={form.purpose}
                  onChange={(inputEvent) =>
                    setForm((previousForm) => ({
                      ...previousForm,
                      purpose: inputEvent.target.value,
                    }))
                  }
                />
              </Col>

              <Col md={3}>
                <Form.Label>Category</Form.Label>

                <Form.Select
                  value={form.category}
                  disabled={categoriesLoading}
                  onChange={(inputEvent) =>
                    handleCategorySelection(
                      inputEvent.target.value,
                      "add"
                    )
                  }
                >
                  <option value="">
                    {categoriesLoading
                      ? "Loading categories..."
                      : "Select category"}
                  </option>

                  {renderCategoryOptions("add-category")}
                </Form.Select>
              </Col>

              <Col md={2}>
                <Form.Label>Amount (₹)</Form.Label>

                <Form.Control
                  type="number"
                  min="0"
                  step="0.01"
                  value={form.amount}
                  onChange={(inputEvent) =>
                    setForm((previousForm) => ({
                      ...previousForm,
                      amount: inputEvent.target.value,
                    }))
                  }
                />
              </Col>

              <Col md={3}>
                <Form.Label>Expense Date</Form.Label>

                <Form.Control
                  type="date"
                  value={form.expenseDate}
                  onChange={(inputEvent) =>
                    setForm((previousForm) => ({
                      ...previousForm,
                      expenseDate: inputEvent.target.value,
                    }))
                  }
                />
              </Col>

              <Col md={3}>
                <Form.Label>Payment Mode</Form.Label>

                <Form.Select
                  value={form.paymentMode}
                  onChange={(inputEvent) =>
                    setForm((previousForm) => ({
                      ...previousForm,
                      paymentMode: inputEvent.target.value,
                    }))
                  }
                >
                  <option value="">Select payment mode</option>
                  {renderPaymentModes("add-payment")}
                </Form.Select>
              </Col>

              <Col md={4}>
                <Form.Label>
                  Paid By Committee Member
                </Form.Label>

                <Form.Select
                  value={
                    form.paidByUid
                      ? `uid:${form.paidByUid}`
                      : form.paidByName
                      ? `name:${form.paidByName}`
                      : ""
                  }
                  onChange={(inputEvent) =>
                    handlePaidByChange(
                      inputEvent.target.value,
                      false
                    )
                  }
                >
                  <option value="">
                    Select committee member
                  </option>

                  {renderCommitteeOptions("add-payer")}
                </Form.Select>
              </Col>

              <Col md={3}>
                <Form.Label>Paid By Name</Form.Label>

                <Form.Control
                  type="text"
                  value={form.paidByName}
                  placeholder="Optional manual name"
                  onChange={(inputEvent) =>
                    setForm((previousForm) => ({
                      ...previousForm,
                      paidByUid: "",
                      paidByName: inputEvent.target.value,
                    }))
                  }
                />
              </Col>

              <Col md={2}>
                <Form.Label>Receipt No</Form.Label>

                <Form.Control
                  type="text"
                  value={form.receiptNo}
                  onChange={(inputEvent) =>
                    setForm((previousForm) => ({
                      ...previousForm,
                      receiptNo: inputEvent.target.value,
                    }))
                  }
                />
              </Col>
            </Row>

            <div className="mt-3">
              <Button
                variant="primary"
                onClick={addExpense}
                disabled={
                  adding ||
                  !form.purpose.trim() ||
                  !form.category ||
                  !form.amount ||
                  !form.expenseDate ||
                  !form.paymentMode
                }
              >
                {adding ? "Saving..." : "Add Expense"}
              </Button>
            </div>
          </Card.Body>
        </Card>
      )} */}

      <Card className="mb-3">

        {/* <Card.Header>
  <div className="d-flex flex-wrap align-items-center justify-content-between gap-2">
    <strong>Expense Filters</strong>

    <div className="d-flex gap-2 flex-wrap">

      {canEditExpenses && (
        <Button
          variant="success"
          size="sm"
          onClick={openAddExpenseModal}
        >
          + Add Expense
        </Button>
      )}

      <Button
        variant="outline-secondary"
        size="sm"
        onClick={resetFilters}
        disabled={!hasActiveFilters}
      >
        Clear Filters
      </Button>

    </div>
  </div>
</Card.Header> */}

<Card.Header>
  <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-2">
    <div className="d-flex flex-wrap align-items-center gap-2">
      <strong>Expense Filters</strong>

      <Badge
        bg={hasActiveFilters ? "primary" : "secondary"}
        className="px-3 py-2"
      >
        {filterTotalLabel}
      </Badge>
    </div>

    <div className="d-flex flex-wrap gap-2">
      {canEditExpenses && (
        <Button
          type="button"
          variant="success"
          size="sm"
          onClick={openAddExpenseModal}
        >
          + Add Expense
        </Button>
      )}

      <Button
        type="button"
        variant="outline-secondary"
        size="sm"
        onClick={resetFilters}
        disabled={!hasActiveFilters}
      >
        Clear Filters
      </Button>
    </div>
  </div>
</Card.Header>

        <Card.Body>
          <Row className="g-3">
            <Col md={3}>
              <Form.Label>Category</Form.Label>

              <Form.Select
                value={categoryFilter}
                onChange={(inputEvent) =>
                  setCategoryFilter(inputEvent.target.value)
                }
              >
                <option value="">All Categories</option>

                {categoryOptions.map((category) => (
                  <option
                    key={`filter-category-${category}`}
                    value={category}
                  >
                    {category}
                  </option>
                ))}
              </Form.Select>
            </Col>

            <Col md={3}>
              <Form.Label>Paid By</Form.Label>

              <Form.Select
                value={paidByFilter}
                onChange={(inputEvent) =>
                  setPaidByFilter(inputEvent.target.value)
                }
              >
                <option value="">All Payers</option>

                {paidByFilterOptions.map((option) => (
                  <option
                    key={option.value}
                    value={option.value}
                  >
                    {option.label}
                  </option>
                ))}
              </Form.Select>
            </Col>

            <Col md={2}>
              <Form.Label>Payment Mode</Form.Label>

              <Form.Select
                value={paymentModeFilter}
                onChange={(inputEvent) =>
                  setPaymentModeFilter(
                    inputEvent.target.value
                  )
                }
              >
                <option value="">All Payment Modes</option>
                {renderPaymentModes("filter-payment")}
              </Form.Select>
            </Col>

            <Col md={2}>
              <Form.Label>From Date</Form.Label>

              <Form.Control
                type="date"
                value={fromDateFilter}
                max={toDateFilter || undefined}
                onChange={(inputEvent) =>
                  setFromDateFilter(inputEvent.target.value)
                }
              />
            </Col>

            <Col md={2}>
              <Form.Label>To Date</Form.Label>

              <Form.Control
                type="date"
                value={toDateFilter}
                min={fromDateFilter || undefined}
                onChange={(inputEvent) =>
                  setToDateFilter(inputEvent.target.value)
                }
              />
            </Col>
          </Row>

          <div className="mt-3 text-muted small">
            Showing {sortedExpenses.length} of{" "}
            {expenses.length} expenses
          </div>
        </Card.Body>
      </Card>

      {error && <Alert variant="danger">{error}</Alert>}

      {loading ? (
        <div className="d-flex align-items-center">
          <Spinner
            animation="border"
            size="sm"
            className="me-2"
          />

          <span>Loading expenses...</span>
        </div>
      ) : (
        <Table bordered hover responsive size="sm">
         <thead className="table-light">
  <tr>
    <th
      className="text-center text-nowrap"
      style={{ width: 70 }}
    >
      S.No
    </th>
 <th className="text-nowrap">Expense Date</th>
  <th className="text-nowrap">Amount (₹)</th>
    <th>Purpose</th>
    <th>Category</th>
    <th className="text-nowrap">Amount (₹)</th>
    <th>Paid By</th>
    {/* <th className="text-nowrap">Expense Date</th> */}
    <th className="text-nowrap">Payment Mode</th>
    <th>Receipt</th>

    {canEditExpenses && (
      <th style={{ minWidth: 150 }}>
        Actions
      </th>
    )}
  </tr>
</thead>

          <tbody>
            {filteredExpenses.length === 0 ? (
              <tr>
                <td
  colSpan={canEditExpenses ? 9 : 8}
  className="text-center py-4 text-muted"
>
                  {expenses.length === 0
                    ? "No expenses yet"
                    : "No expenses match the filters"}
                </td>
              </tr>
            ) : (
              sortedExpenses.map((expense, index) => {
                const paidBy = expense.paidByUid
                  ? residentLabelByUid(expense.paidByUid) ||
                    expense.paidByName ||
                    expense.paidByUid
                  : expense.paidByName || "Not specified";

               return (
  <tr key={expense.id}>
    <td className="text-center fw-semibold">
      {index + 1}
    </td>
     <td>
                      {formatDisplayDate(expense.expenseDate || "-")}
                    </td>
                     <td>₹ {fmt(expense.amount)}</td>

    <td>
      {expense.purpose || "Not specified"}
    </td>

                    <td>
                      {expense.category || "Not specified"}
                    </td>

                    {/* <td>₹ {fmt(expense.amount)}</td> */}

                    <td>{paidBy}</td>

                    {/* <td>
                      {formatDisplayDate(expense.expenseDate || "-")}
                    </td> */}

                    <td>
                      {expense.paymentMode || "Not specified"}
                    </td>

                    <td>
                      {expense.receiptNo || "NA"}
                    </td>

                    {/* <td>{fmtTs(expense.createdAt)}</td> */}

                    {canEditExpenses && (
                      <td>
                        <div className="d-flex gap-2">
                          <Button
                            variant="outline-secondary"
                            size="sm"
                            onClick={() => openEdit(expense)}
                          >
                            Edit
                          </Button>

                          <Button
                            variant="outline-danger"
                            size="sm"
                            onClick={() =>
                              openDeleteModal(expense)
                            }
                          >
                            Delete
                          </Button>
                        </div>
                      </td>
                    )}
                  </tr>
                );
              })
            )}
          </tbody>
        </Table>
      )}

      <Modal
  show={showAddExpenseModal}
  onHide={closeAddExpenseModal}
  centered
  size="lg"
  backdrop={adding ? "static" : true}
  keyboard={!adding}
>
  <Modal.Header closeButton={!adding}>
    <Modal.Title>Add Expense</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <Row className="g-3">

      <Col xs={12} md={6}>
        <Form.Label>Purpose</Form.Label>
        <Form.Control
          type="text"
          value={form.purpose}
          placeholder="Enter purpose"
          onChange={(e) =>
            setForm((previousForm) => ({
              ...previousForm,
              purpose: e.target.value,
            }))
          }
        />
      </Col>

      <Col xs={12} md={6}>
        <Form.Label>Category</Form.Label>
        <Form.Select
          value={form.category}
          onChange={(e) =>
            handleCategorySelection(
              e.target.value,
              "add"
            )
          }
        >
          <option value="">Select Category</option>

          {renderCategoryOptions("add-modal-category")}
        </Form.Select>
      </Col>

      <Col xs={12} md={4}>
        <Form.Label>Amount (₹)</Form.Label>
        <Form.Control
          type="number"
          min="0"
          step="0.01"
          value={form.amount}
          onChange={(e) =>
            setForm((previousForm) => ({
              ...previousForm,
              amount: e.target.value,
            }))
          }
        />
      </Col>

      <Col xs={12} md={4}>
        <Form.Label>Expense Date</Form.Label>
        <Form.Control
          type="date"
          value={form.expenseDate}
          onChange={(e) =>
            setForm((previousForm) => ({
              ...previousForm,
              expenseDate: e.target.value,
            }))
          }
        />
      </Col>

      <Col xs={12} md={4}>
        <Form.Label>Payment Mode</Form.Label>
        <Form.Select
          value={form.paymentMode}
          onChange={(e) =>
            setForm((previousForm) => ({
              ...previousForm,
              paymentMode: e.target.value,
            }))
          }
        >
          <option value="">
            Select Payment Mode
          </option>

          {renderPaymentModes(
            "add-modal-payment"
          )}
        </Form.Select>
      </Col>

      <Col xs={12} md={4}>
        <Form.Label>
          Paid By Committee Member
        </Form.Label>

        <Form.Select
          value={
            form.paidByUid
              ? `uid:${form.paidByUid}`
              : form.paidByName
              ? `name:${form.paidByName}`
              : ""
          }
          onChange={(e) =>
            handlePaidByChange(
              e.target.value,
              false
            )
          }
        >
          <option value="">
            Select Committee Member
          </option>

          {renderCommitteeOptions(
            "add-modal-payer"
          )}
        </Form.Select>
      </Col>

      <Col xs={12} md={4}>
        <Form.Label>Paid By Name</Form.Label>
        <Form.Control
          type="text"
          value={form.paidByName}
          placeholder="Optional manual name"
          onChange={(e) =>
            setForm((previousForm) => ({
              ...previousForm,
              paidByUid: "",
              paidByName: e.target.value,
            }))
          }
        />
      </Col>

      <Col xs={12} md={4}>
        <Form.Label>Receipt No</Form.Label>
        <Form.Control
          type="text"
          value={form.receiptNo}
          onChange={(e) =>
            setForm((previousForm) => ({
              ...previousForm,
              receiptNo: e.target.value,
            }))
          }
        />
      </Col>

    </Row>
  </Modal.Body>

  <Modal.Footer>

    <Button
      variant="secondary"
      onClick={closeAddExpenseModal}
      disabled={adding}
    >
      Cancel
    </Button>

    <Button
      variant="success"
      onClick={addExpense}
      disabled={
        adding ||
        !form.purpose.trim() ||
        !form.category ||
        !form.amount ||
        !form.expenseDate ||
        !form.paymentMode
      }
    >
      {adding
        ? "Saving..."
        : "Add Expense"}
    </Button>

  </Modal.Footer>
</Modal>

      <Modal
        show={showEdit}
        onHide={closeEdit}
        centered
        backdrop={savingEdit ? "static" : true}
        keyboard={!savingEdit}
      >
        <Modal.Header closeButton={!savingEdit}>
          <Modal.Title>Edit Expense</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {editExpense ? (
            <Row className="g-3">
             <Col xs={12} md={6}>
                <Form.Label>Purpose</Form.Label>

                <Form.Control
                  type="text"
                  value={editForm.purpose}
                  onChange={(inputEvent) =>
                    setEditForm((previousForm) => ({
                      ...previousForm,
                      purpose: inputEvent.target.value,
                    }))
                  }
                />
              </Col>

             <Col xs={12} md={6}>
                <Form.Label>Category</Form.Label>

                <Form.Select
                  value={editForm.category}
                  onChange={(inputEvent) =>
                    handleCategorySelection(
                      inputEvent.target.value,
                      "edit"
                    )
                  }
                >
                  <option value="">Select category</option>
                  {renderCategoryOptions("edit-category")}
                </Form.Select>
              </Col>

              <Col md={4}>
                <Form.Label>Amount (₹)</Form.Label>

                <Form.Control
                  type="number"
                  min="0"
                  step="0.01"
                  value={editForm.amount}
                  onChange={(inputEvent) =>
                    setEditForm((previousForm) => ({
                      ...previousForm,
                      amount: inputEvent.target.value,
                    }))
                  }
                />
              </Col>

              <Col md={4}>
                <Form.Label>Expense Date</Form.Label>

                <Form.Control
                  type="date"
                  value={editForm.expenseDate}
                  onChange={(inputEvent) =>
                    setEditForm((previousForm) => ({
                      ...previousForm,
                      expenseDate: inputEvent.target.value,
                    }))
                  }
                />
              </Col>

              <Col md={4}>
                <Form.Label>Payment Mode</Form.Label>

                <Form.Select
                  value={editForm.paymentMode}
                  onChange={(inputEvent) =>
                    setEditForm((previousForm) => ({
                      ...previousForm,
                      paymentMode: inputEvent.target.value,
                    }))
                  }
                >
                  <option value="">Select payment mode</option>
                  {renderPaymentModes("edit-payment")}
                </Form.Select>
              </Col>

              <Col md={8}>
                <Form.Label>
                  Paid By Committee Member
                </Form.Label>

                <Form.Select
                  value={
                    editForm.paidByUid
                      ? `uid:${editForm.paidByUid}`
                      : editForm.paidByName
                      ? `name:${editForm.paidByName}`
                      : ""
                  }
                  onChange={(inputEvent) =>
                    handlePaidByChange(
                      inputEvent.target.value,
                      true
                    )
                  }
                >
                  <option value="">
                    Select committee member
                  </option>

                  {renderCommitteeOptions("edit-payer")}
                </Form.Select>
              </Col>

              <Col md={8}>
                <Form.Label>Paid By Name</Form.Label>

                <Form.Control
                  type="text"
                  value={editForm.paidByName}
                  placeholder="Optional manual name"
                  onChange={(inputEvent) =>
                    setEditForm((previousForm) => ({
                      ...previousForm,
                      paidByUid: "",
                      paidByName: inputEvent.target.value,
                    }))
                  }
                />
              </Col>

              <Col md={4}>
                <Form.Label>Receipt No</Form.Label>

                <Form.Control
                  type="text"
                  value={editForm.receiptNo}
                  onChange={(inputEvent) =>
                    setEditForm((previousForm) => ({
                      ...previousForm,
                      receiptNo: inputEvent.target.value,
                    }))
                  }
                />
              </Col>
            </Row>
          ) : (
            <Alert variant="warning">
              No expense selected.
            </Alert>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={closeEdit}
            disabled={savingEdit}
          >
            Cancel
          </Button>

          <Button
            variant="primary"
            onClick={saveEdit}
            disabled={
              savingEdit ||
              !editForm.purpose.trim() ||
              !editForm.category ||
              !editForm.amount ||
              !editForm.expenseDate ||
              !editForm.paymentMode
            }
          >
            {savingEdit ? "Saving..." : "Save Changes"}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
  show={showDeleteModal}
  onHide={closeDeleteModal}
  centered
  backdrop="static"
  keyboard={!deletingExpense}
>
  <Modal.Header closeButton={!deletingExpense}>
    <Modal.Title>Delete Expense</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    {deleteError && (
      <Alert variant="danger">
        {deleteError}
      </Alert>
    )}

    {expenseToDelete ? (
      <>
        <Alert variant="warning">
          This action permanently deletes the selected expense.
          This action cannot be undone.
        </Alert>

        <Card className="mb-3">
          <Card.Body>
            <Row className="g-2">
              <Col xs={5}>
                <strong>Purpose</strong>
              </Col>

              <Col xs={7}>
                {expenseToDelete.purpose || "Not specified"}
              </Col>

              <Col xs={5}>
                <strong>Category</strong>
              </Col>

              <Col xs={7}>
                {expenseToDelete.category || "Not specified"}
              </Col>

              <Col xs={5}>
                <strong>Amount</strong>
              </Col>

              <Col xs={7}>
                ₹ {fmt(expenseToDelete.amount)}
              </Col>

              <Col xs={5}>
                <strong>Expense Date</strong>
              </Col>

              <Col xs={7}>
                {formatDisplayDate(
                  expenseToDelete.expenseDate
                )}
              </Col>

              <Col xs={5}>
                <strong>Payment Mode</strong>
              </Col>

              <Col xs={7}>
                {expenseToDelete.paymentMode ||
                  "Not specified"}
              </Col>
            </Row>
          </Card.Body>
        </Card>

        <Form.Group>
          <Form.Label>
            Enter DELETE to confirm
          </Form.Label>

          <Form.Control
            type="text"
            value={deleteConfirmation}
            placeholder="DELETE"
            autoComplete="off"
            autoFocus
            disabled={deletingExpense}
            onChange={(inputEvent) => {
              setDeleteConfirmation(
                inputEvent.target.value
              );

              if (deleteError) {
                setDeleteError("");
              }
            }}
            onKeyDown={(keyboardEvent) => {
              if (
                keyboardEvent.key === "Enter" &&
                deleteConfirmation.trim() === "DELETE" &&
                !deletingExpense
              ) {
                keyboardEvent.preventDefault();
                confirmDeleteExpense();
              }
            }}
          />

          <Form.Text className="text-muted">
            The Delete Expense button is enabled only when
            DELETE is entered exactly in uppercase.
          </Form.Text>
        </Form.Group>
      </>
    ) : (
      <Alert variant="warning">
        No expense selected.
      </Alert>
    )}
  </Modal.Body>

  <Modal.Footer>
    <Button
      variant="secondary"
      onClick={closeDeleteModal}
      disabled={deletingExpense}
    >
      Cancel
    </Button>

    <Button
      variant="danger"
      onClick={confirmDeleteExpense}
      disabled={
        deletingExpense ||
        !expenseToDelete?.id ||
        deleteConfirmation.trim() !== "DELETE"
      }
    >
      {deletingExpense
        ? "Deleting..."
        : "Delete Expense"}
    </Button>
  </Modal.Footer>
</Modal>


      <Modal
        show={showCategoryModal}
        onHide={closeCategoryModal}
        centered
        backdrop={savingCategory ? "static" : true}
        keyboard={!savingCategory}
      >
        <Modal.Header closeButton={!savingCategory}>
          <Modal.Title>
            Add New Expense Category
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {categoryError && (
            <Alert variant="danger">
              {categoryError}
            </Alert>
          )}

          <Form.Group>
            <Form.Label>Category Name</Form.Label>

            <Form.Control
              type="text"
              value={newCategoryName}
              placeholder="Example: Decoration or Food"
              autoFocus
              onChange={(inputEvent) => {
                setNewCategoryName(inputEvent.target.value);
                setCategoryError("");
              }}
              onKeyDown={(keyboardEvent) => {
                if (
                  keyboardEvent.key === "Enter" &&
                  !savingCategory
                ) {
                  keyboardEvent.preventDefault();
                  saveNewCategory();
                }
              }}
            />

            <Form.Text className="text-muted">
              The category will be saved and shown in the
              dropdown.
            </Form.Text>
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={closeCategoryModal}
            disabled={savingCategory}
          >
            Cancel
          </Button>

          <Button
            variant="primary"
            onClick={saveNewCategory}
            disabled={
              savingCategory || !newCategoryName.trim()
            }
          >
            {savingCategory ? "Adding..." : "Add Category"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}